import {onDomReady} from "./observer.js";

class Faq {
    constructor() {
        this.options = {
            faqQuestions: '[data-faq-item]',
        };

        this.elements = {
            faqQuestionsElements: document.querySelectorAll(this.options.faqQuestions),
        };

        this.init();
    }

    init() {
        if (this.elements.faqQuestionsElements) {
            const faqQuestionsElementsVar = this.elements.faqQuestionsElements;
            faqQuestionsElementsVar.forEach((faqQuestionsElementsCur) => {
                faqQuestionsElementsCur.addEventListener('click', (event) => {
                    faqQuestionsElementsCur.classList.toggle('_opened');
                });
            });
        }
    }
}

onDomReady(() => {
    const header = new Faq();
}, false);